// src/components/Sidebar.jsx
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const NAV_ICONS = {
  '/': '',
  '/orders': '',
  '/map': '',
  '/riders': '',
  '/revenue': '',
  '/history': '',
  '/admin': '',
};

export default function Sidebar({ activeOrdersCount, mobileOpen, onMobileClose }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const allNav = [
    { label: 'Dashboard', path: '/', roles: ['Admin', 'Dispatcher'] },
    { label: 'Orders', path: '/orders', roles: ['Admin', 'Dispatcher'], badge: true },
    { label: 'Live Map', path: '/map', roles: ['Admin', 'Dispatcher'] },
    { label: 'Riders', path: '/riders', roles: ['Admin', 'Dispatcher'] },
    { label: 'Revenue', path: '/revenue', roles: ['Admin', 'Dispatcher'] },
    { label: 'Order History', path: '/history', roles: ['Admin', 'Dispatcher'] },
    { label: 'User Management', path: '/admin', roles: ['Admin'] },
  ];

  const navItems = allNav.filter(n => n.roles.includes(user?.role));

  const handleNav = (path) => {
    navigate(path);
    if (onMobileClose) onMobileClose();
  };

  return (
    <aside className={`sidebar ${mobileOpen ? 'open' : ''}`}>

      {/* Mobile close button */}
      <button className="sidebar-close-btn" onClick={onMobileClose} aria-label="Close menu">
        ✕
      </button>

      <div className="sidebar-logo">
        <img src="/honcho1.png" alt="Logo" style={{ width: 200, height: 100, objectFit: 'contain' }} />
        <div className="sidebar-logo-name">Honcho Xpress</div>
        <div className="sidebar-logo-tagline">Management System</div>
      </div>

      <nav className="sidebar-nav">
        <div className="nav-section-label">Main Menu</div>
        {navItems.map(item => {
          const isActive = location.pathname === item.path ||
            (item.path !== '/' && location.pathname.startsWith(item.path));
          return (
            <button key={item.path} className={`nav-link ${isActive ? 'active' : ''}`}
              onClick={() => handleNav(item.path)}>
              <span className="nav-link-icon">{NAV_ICONS[item.path] || ''}</span>
              {item.label}
              {item.badge && activeOrdersCount > 0 && (
                <span className="nav-link-badge">{activeOrdersCount}</span>
              )}
            </button>
          );
        })}
      </nav>

      <div className="sidebar-user">
        <div className="sidebar-user-avatar">{user?.name?.charAt(0)?.toUpperCase() || 'U'}</div>
        <div style={{ flex: 1, overflow: 'hidden' }}>
          <div className="sidebar-user-name">{user?.name || 'User'}</div>
          <div className="sidebar-user-role">{user?.role}</div>
        </div>
        <button className="sidebar-logout-btn" onClick={logout} title="Logout">logout</button>
      </div>
    </aside>
  );
}